import { urlParamsToMap } from './lib/util/urls'

const baseUrl = '/copra-admin'

if (window.location.search.indexOf('origin=') !== -1) {
  const params = urlParamsToMap(window.location.search)
  if (params.origin) {
    localStorage.setItem('origin', params.origin)
  }
}

export const routeToPath = (path: string) => {
  if (!window.top) {
    return
  }
  window.top.location.href = baseUrl + path
}

export const routeBackToDashboard = () => {
  const origin = localStorage.getItem('origin')
  if (origin) {
    window.location.href = origin
  }
}
